/**
 * Labstep
 *
 * @module components/EntityUserRoleRequirement/Form/ShowEdit/NumberRequired
 * @desc   Set numberRequired for EntityUserRoleRequirement
 */

import { fieldEntityUserRoleRequirementNumberRequired } from 'labstep-web/components/EntityUserRoleRequirement/Form/fields';
import { FormShowEditText } from 'labstep-web/core/Form/ShowEdit/Text';
import type React from 'react';
import type { EntityUserRoleRequirementFormShowEditNumberRequiredProps } from './types';

export const EntityUserRoleRequirementFormShowEditNumberRequired: React.FC<
  EntityUserRoleRequirementFormShowEditNumberRequiredProps
> = ({ entityUserRoleRequirement }) => {
  return (
    <FormShowEditText
      entityName={entityUserRoleRequirement.entityName}
      entity={entityUserRoleRequirement}
      field={fieldEntityUserRoleRequirementNumberRequired}
      placeholder="Enter number required"
    >
      {entityUserRoleRequirement.number_required}
    </FormShowEditText>
  );
};
